import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';    
import { VerificationLoginComponent } from './page/verification-login/verification-login.component';

const routes: Routes = [
  { path: '',  
    component: VerificationLoginComponent,
    data: {
      queryParams: ['code']
  } }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class B2cVerificationRoutingModule { }
